/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EvalSampleObject,
  EvalSampleObject$inboundSchema,
  EvalSampleObject$Outbound,
  EvalSampleObject$outboundSchema,
} from "./evalsampleobject.js";

export type EvalSampleList = {
  object: "list";
  data: Array<EvalSampleObject>;
  firstId?: string | undefined;
  lastId?: string | undefined;
  hasMore: boolean;
};

/** @internal */
export const EvalSampleList$inboundSchema: z.ZodType<
  EvalSampleList,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(EvalSampleObject$inboundSchema),
  first_id: z.string().optional(),
  last_id: z.string().optional(),
  has_more: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    "first_id": "firstId",
    "last_id": "lastId",
    "has_more": "hasMore",
  });
});
/** @internal */
export type EvalSampleList$Outbound = {
  object: "list";
  data: Array<EvalSampleObject$Outbound>;
  first_id?: string | undefined;
  last_id?: string | undefined;
  has_more: boolean;
};

/** @internal */
export const EvalSampleList$outboundSchema: z.ZodType<
  EvalSampleList$Outbound,
  z.ZodTypeDef,
  EvalSampleList
> = z.object({
  object: z.literal("list"),
  data: z.array(EvalSampleObject$outboundSchema),
  firstId: z.string().optional(),
  lastId: z.string().optional(),
  hasMore: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    firstId: "first_id",
    lastId: "last_id",
    hasMore: "has_more",
  });
});

export function evalSampleListToJSON(evalSampleList: EvalSampleList): string {
  return JSON.stringify(EvalSampleList$outboundSchema.parse(evalSampleList));
}
export function evalSampleListFromJSON(
  jsonString: string,
): SafeParseResult<EvalSampleList, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvalSampleList$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvalSampleList' from JSON`,
  );
}
